import html from './unavailabilityDetailsView.html';

class UnavailabilityCtrl {
  constructor(
    Authentication,
    PersonaCollection,
    AvailabilityUtils,
    NoScrollService,
    sdk,
    $scope,
    $uibModal,
    $rootScope,
    $state
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      AvailabilityUtils,
      NoScrollService,
      sdk,
      $scope,
      $uibModal,
      $rootScope,
      $state,
    });
  }

  $onInit() {
    this.isLoading = true;
    this.currentUser = this.Authentication.user;
    this.readOnly = !this.currentUser;

    this.NoScrollService.setScrollDisabled(true);
    this.loadData();

    this.unwatch = this.$scope.$watch('ctrl.$state.params.tab', (next, prev) => {
      if (next !== prev) {
        this.$state.go('shifts', {}, { reload: false });
      }
    });
  }

  $onDestroy() {
    this.unwatch();
    this.NoScrollService.setScrollDisabled(false);
  }

  async loadData() {
    const { userId, id, day } = this.$state.params;
    this.userId = userId;

    try {
      if (!id && !userId) {
        throw 'missing unavailability data';
      }

      if (!id) {
        this.user = this.PersonaCollection.personasDict[userId];
        this.isLoading = false;
        this.setData = [
          this.AvailabilityUtils.createAvailabilitySet(this.user, {
            details: { start: day, interval: this.sdk('constants').UNAVAILABILITY_NO_REPEAT_VALUE },
          }),
        ];
        return false;
      }

      this.isLoading = true;
      const response = await this.Authentication.sendRequest({
        path: `availability/event/${id}`,
        method: 'get',
      });

      this.setData = [this.AvailabilityUtils.getUnavailabilitySetToDisplay(response.data)];
      this.user = this.PersonaCollection.personasDict[response.data?.user?.id];
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.$state.go('shifts', {}, { reload: false });
    }
  }

  get shouldRequest() {
    return this.AvailabilityUtils.shouldRequest();
  }

  get submitDisabled() {
    return !this.AvailabilityUtils.canSaveSets(this.setData);
  }

  async submit() {
    if (this.form.$invalid) {
      throw new Error('invalid form');
    }

    await this.AvailabilityUtils.saveAvailability(this.setData);
    this.form.$setPristine();
    this.close();
  }

  close() {
    this.$state.go('shifts', {}, { reload: false });
  }
}

export default {
  controller: UnavailabilityCtrl,
  controllerAs: 'ctrl',
  templateUrl: html,
};
